import { animate, style, transition, trigger } from '@angular/animations';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { isPlatformBrowser, NgClass, NgTemplateOutlet } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    model,
    PLATFORM_ID,
    ViewEncapsulation,
} from '@angular/core';
import { DEALER_THEME } from '@hyundai/shared-lib';

@Component({
    selector: 'ui-input-select-wrapper',
    templateUrl: './input-select-wrapper.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, OverlayModule, NgTemplateOutlet],
    animations: [
        trigger('slideUpDown', [
            transition(':enter', [
                style({ 'max-height': '0' }),
                animate('0.2s ease-in-out', style({ 'max-height': '*' })),
            ]),
        ]),
    ],
})
export class InputSelectWrapperComponent {
    overlay = inject(Overlay);
    platformId = inject(PLATFORM_ID);

    isBrowser = isPlatformBrowser(this.platformId);

    scroll = this.overlay.scrollStrategies.close();

    theme = input<DEALER_THEME>('light');
    noOverlay = input(false, { transform: booleanAttribute });
    open = model(false);
}
